import PublishedMark from "./PublishedMarkTable";

export default PublishedMark;
